import { isProductionStage } from '../../Utils/environment';

const isProduction = isProductionStage();

export const FEATURE_FLAGS = {
  INSTORE_MODULE_V2: 'INSTORE-MODULE-V2',
};

// LaunchDarkly configuration constants
export const LAUNCHDARKLY_CONFIG = {
  CLIENT_SIDE_ID: isProduction
    ? process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID_PRODUCTION
    : process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID,
  ANONYMOUS_USER: {
    kind: 'user',
    key: 'anonymous',
  },
  INITIALIZATION_TIMEOUT_SECONDS: 3,
};
